// check all download button
function checkAll(type, container) {
	container
		.find("." + type)
		.find("input")
		.prop("checked", true);

	let filesToDownload = [];
	const downloadFileCheckboxes = document.querySelectorAll(
		".tab-content__ti.active .tab-content__ti__downloads__download input[type=checkbox]",
	);
	filesToDownload = Array.from(downloadFileCheckboxes).filter((i) => i.checked);

	container
		.find(".download-button--plans")
		.attr("href", "/wp-json/d6/v1/downloads/" + filesToDownload.map((i) => i.dataset.id).join(","));

	// add download button
	if (type === "tab-content__ti__downloads__download") {
		container.find(".details__download-button").removeClass("disabled");
	}
}

// check all download button
function checkSome(type, container) {
	let filesToDownload = [];
	const downloadFileCheckboxes = document.querySelectorAll(
		".tab-content__ti.active .tab-content__ti__downloads__download input[type=checkbox]",
	);

	if (downloadFileCheckboxes.length) {
		filesToDownload = Array.from(downloadFileCheckboxes).filter((i) => i.checked);

		container
			.find(".download-button--plans")
			.attr("href", "/wp-json/d6/v1/downloads/" + filesToDownload.map((i) => i.dataset.id).join(","));

		// add download button
		if (type === "tab-content__ti__downloads__download") {
			container.find(".details__download-button").removeClass("disabled");
		}
	} else {
		// disable download button
		if (type === "tab-content__ti__downloads__download") {
			container.find(".details__download-button").addClass("disabled");
		}

		container.find(".download-button--plans").attr("href", "#");
	}
}

// uncheck all download button
function uncheckAll(type, container) {
	container
		.find("." + type)
		.find("input")
		.prop("checked", false);

	// disable download button
	if (type === "tab-content__ti__downloads__download") {
		container.find(".details__download-button").addClass("disabled");
	}

	container.find(".download-button--plans").attr("href", "#");
}

jQuery(function ($) {
	let container;

	// product tabs - specs/tech info
	$(".product-tabs__tabs-tab").on("click", function () {
		let clickedTab = $(this).attr("data-id");
		if (!$(this).hasClass("active-tab")) {
			$(".product-tabs__tabs-tab").removeClass("active-tab");
			$(".tab-content").removeClass("active-tab-content");
			$(this).addClass("active-tab");
			$(".tab-content-" + clickedTab).addClass("active-tab-content");
		} else {
			$(".product-tabs__tabs-tab").removeClass("active-tab");
			$(".tab-content").removeClass("active-tab-content");
		}
	});

	// active container
	$(".tab-content__ti").on("click", function () {
		$(this).addClass("active").siblings().removeClass("active");
	});

	// filter box
	$(".tab-content__ti__filter__label").on("click", function () {
		const t = $(this);
		container = $(this).closest(".tab-content__ti");

		if (t.hasClass("open-filter")) {
			t.removeClass("open-filter");
			container.find(".tab-content__ti__sort__label").css({ "z-index": "10", opacity: "1" });
			container.find(".tab-content__ti__filter__checks").removeClass("open-filter-checks");
		} else {
			t.addClass("open-filter");
			container.find(".tab-content__ti__sort__label").css({ "z-index": "-1", opacity: ".5" });
			container.find(".tab-content__ti__filter__checks").addClass("open-filter-checks");
		}
	});

	// sort box
	$(".tab-content__ti__sort__label").on("click", function () {
		const t = $(this);
		container = $(this).closest(".tab-content__ti");

		if (t.hasClass("open-filter")) {
			t.removeClass("open-filter");
			container.find(".tab-content__ti__filter__label").css({ "z-index": "10", opacity: "1" });
			container.find(".tab-content__ti__sort__checks").removeClass("open-filter-checks");
		} else {
			t.addClass("open-filter");
			container.find(".tab-content__ti__filter__label").css({ "z-index": "-1", opacity: ".5" });
			container.find(".tab-content__ti__sort__checks").addClass("open-filter-checks");
		}
	});

	// select all downloads
	$(".selectAllDownloads").on("change", function () {
		container = $(this).closest(".tab-content__ti");

		if ($(this).hasClass("allChecked")) {
			$(this).removeClass("allChecked");
			uncheckAll("tab-content__ti__downloads__download", container);
		} else {
			$(this).addClass("allChecked");

			checkAll("tab-content__ti__downloads__download", container);
		}
	});

	// download select all check
	$(".tab-content__ti__downloads :checkbox").on("change", function () {
		container = $(this).closest(".tab-content__ti");

		if (container.find(".tab-content__ti__downloads :checkbox:not(:checked)").length == 0) {
			container.find(".selectAllDownloads").prop("checked", true).addClass("allChecked");
		} else {
			container.find(".selectAllDownloads").prop("checked", false).removeClass("allChecked");
		}

		if (container.find(".tab-content__ti__downloads :checkbox(:checked)").length > 0) {
			container.find(".details__download-button").removeClass("disabled");
		}
		checkSome("tab-content__ti__downloads__download", container);
	});

	// select all categories
	$(".select-all-cats").on("change", function () {
		container = $(this).closest(".tab-content__ti");

		if ($(this).hasClass("allChecked")) {
			$(this).removeClass("allChecked");
			uncheckAll("tab-content__ti__filter__checks__filterable__label", container);
		} else {
			$(this).addClass("allChecked");
			checkAll("tab-content__ti__filter__checks__filterable__label", container);
		}
	});

	// category select all check
	$(".tab-content__ti__filter__checks__filterable :checkbox").on("change", function () {
		container = $(this).closest(".tab-content__ti");

		if (container.find(".tab-content__ti__filter__checks__filterable :checkbox:not(:checked)").length == 0) {
			container.find(".select-all-cats").prop("checked", true).addClass("allChecked");
		} else {
			container.find(".select-all-cats").prop("checked", false).removeClass("allChecked");
		}
	});

	// sort boxes
	$(".tab-content__ti__sort__checks__sortable__check").on("change", function () {
		const t = $(this);

		container.find(".tab-content__ti__sort__checks__sortable__check").prop("checked", false);
		t.prop("checked", true);
	});
});
